import 'react';
import { useTheme, jsx } from '@emotion/react';
import Style from './style.js';

var getStyles = _ref => {
  var {
    theme,
    type
  } = _ref;
  // Default properties correspond to 'error' type
  var backgroundColor = theme.COLORS.error;
  var textColor = theme.COLORS.white;

  if (type === 'primary') {
    backgroundColor = theme.COLORS.primary;
  }

  if (type === 'success') {
    backgroundColor = theme.COLORS.success;
  }

  if (type === 'tertiary') {
    backgroundColor = theme.COLORS.defaultLight;
    textColor = theme.COLORS.primary;
  }

  if (type === 'white') {
    backgroundColor = theme.COLORS.white;
    textColor = theme.COLORS.primary;
  }

  return {
    backgroundColor,
    textColor
  };
};
/**
 * Indicators are used in navigation to help with wayfinding for messages and notifications.
 * It can also be used for non-navigational purposes for information-intensive pages.
 */


var Indicator = _ref2 => {
  var {
    text,
    type = 'error'
  } = _ref2;
  var theme = useTheme();
  var {
    backgroundColor,
    textColor
  } = getStyles({
    theme,
    type
  });
  return jsx(Style.IndicatorContainer, {
    backgroundColor: backgroundColor,
    textColor: textColor
  }, jsx("div", null, text));
};

export { Indicator };
